import React from "react";
import ESPServiceRequestGrid from "../../components/EServicePartnerServiceRequests/ESPServiceRequestGrid";
import ESPNavbar from "./ESPNavbar";
import { useState } from "react";
import api from "../../utils/api";
import { useEffect } from "react";
import { useLayoutEffect } from "react";
import ConfirmationModalSmall from "../../components/ServicePackaging/ConfirmationModalSmall";
import { toast } from "react-toastify";
import find from "lodash/find";
import Spinner from "../../common/Spinner/Spinner";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { Button } from "../../common/Button/Button";
import ESPTargetsConfigurationGrid from "../../components/EServicePartnerServiceRequests/ESPTargetsConfigurationGrid"

export default function ESPTargetConfiguration(props)
{
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const[activePage,setActivePage]=useState(""); 
    const [ESPData, setESPData] = useState([]);
    const [activeFocus, setactiveFocus] = useState("");
    const [activeRow, setactiveRow] = useState(null);
    const [CursorPosition,setCursorPosition,] = useState(
        {
            selectionStart: 0,
		    selectionEnd: 0,
	    }
    );
    
	
    const [serviceNameOption, setServiceNameOption] = useState([]);
    const [YearOptions,setYearOptions,] = useState([]);
    const [PeriodOptions,setPeriodOptions,] = useState([
		{
			value: "Quarter",
			label: "Quarterly",
		},
		{
			value: "Month",
			label: "Monthly",
        },
	]);

    const [QuarterOptions,setQuarterOptions,] = useState([
		{
			value: "Q1",
			label: "Q1 (April to Jun)",
		},
		{
			value: "Q2",
			label: "Q2 (July to Sep)",
		},
        {
			value: "Q3",
			label: "Q3 (Oct to Dec)",
		},
        {
			value: "Q4",
			label: "Q4 (Jan to Mar)",
		},
	]);

    const [MonthOptions,setMonthOptions,] = useState([
		{
			value: "January",
			label: "January",
		},
		{
			value: "February",
			label: "February",
		},
        {
			value: "March",
			label: "March",
		},
        {
			value: "April",
			label: "April",
		},
        {
			value: "May",
			label: "May",
		},
        {
			value: "June",
			label: "June",
		},
        {
			value: "July",
			label: "July",
		},
        {
			value: "August",
			label: "August",
		},
        {
			value: "September",
			label: "September",
		},
        {
			value: "October",
			label: "October",
		},
        {
			value: "November",
			label: "November",
		},
        {
			value: "December",
			label: "December",
		},
	]);   

    const [selectedYearOption,setSelectedYearOption,] = useState(null);
	const [selectedPeriodOption,setSelectedPeriodOption,] = useState(null);
    const [selectedQuarterOption,setSelectedQuarterOption,] = useState(null);
    const [selectedMonthOption,setSelectedMonthOption,] = useState(null);
    const [selectedServiceNameOption, setSelectedServiceNameOption] = useState(null);

    
    useEffect(() => 
    {
        const user = getUser();
		if (!user) 
        {
			this.props.history.push("/login");
			return;
		}
        const {email}=user;
        const hasAdminRole = user.role.includes(1);
        if (hasAdminRole||email==="aishwarya.kulkarni@deasra.co.in"||email==="nitish.kulkarni@deasra.co.in"||email==="prakash@deasra.co.in") 
        {
            setActivePage("SPTargetsConfiguration");
        }
        else
        {
            setActivePage("No_Access");
        }

        api.getAllServiceRequestsNames().then(({ data }) => {

            let serviceReqNames=[];
            Object.keys(data).map((idx) => {
                if(email==="aishwarya.kulkarni@deasra.co.in"&&data[idx].sServiceCategory==="Market Your Business")
                {
                    serviceReqNames.push({
                        value: data[idx].sServiceCode,
                        label: data[idx].sServiceName
                    });
                }
                else if(email==="nitish.kulkarni@deasra.co.in"&&(data[idx].sServiceCategory==="Legal Compliances"||data[idx].sServiceCategory==="Professional Services"))
                {
                    serviceReqNames.push({
                        value: data[idx].sServiceCode,
                        label: data[idx].sServiceName
                    });
                }
                else if(email==="prakash@deasra.co.in"&&(data[idx].sServiceCategory==="Business Plan & Loan Proposal"||data[idx].sServiceCategory==="Business Process Improvement"))
                {
                    serviceReqNames.push({
                        value: data[idx].sServiceCode,
                        label: data[idx].sServiceName
                    });
                }
                else if(hasAdminRole)
                {
                    serviceReqNames.push({
                        value: data[idx].sServiceCode,
                        label: data[idx].sServiceName
                    });
                }            
            });
            setServiceNameOption(serviceReqNames);
        });

        let years=[];

        for(let year=2021;year<=new Date().getFullYear()+2;year++)
        {
            let label="FY "+year+"-"+(year+1);
            years.push({ value: year, label: label});
        }
        setYearOptions(years);
        
    }, []);

    useEffect(() => 
    {
        setSelectedMonthOption(null);
        setSelectedQuarterOption(null);
        
    }, [selectedPeriodOption]);

    useEffect(() => 
    {
        setESPData([]);
        if(selectedServiceNameOption)
        {
            getESPByServiceCode();
        }
        
    }, [selectedServiceNameOption]);

    const getESPByServiceCode = () => {
		setIsLoading(true);
        let temp = api.getExternalServicePartners({sServiceCode: selectedServiceNameOption.value})
        .then((d) => {	
            setIsLoading(false);
            if(d.data)
            {
                let tempParterList= d.data.map((x) => 
                {
                    x.SignedUpTarget= "";
                    x.DeliveredTarget="";                    
                    return x;
                });
                setESPData(tempParterList);
            }
        }).catch((error) =>
        {
            setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }            
        });
	};

    const onSearchClick = async () => 
    {
        if(!selectedServiceNameOption)
        {
            toast(`Please select service.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
        getESPByServiceCode();        
    };

    const handleInputChange = (name, value,original) => {
        const floatRegExp = new RegExp('^([0-9]+([.][0-9]*)?|[.][0-9]+)$');
        if (value!=''&&floatRegExp.test(value) === false)  
        {
            return;
        }

        let tempParterList= ESPData.map((x) => 
        {
            if(original.id===x.id)
            {
                if(name==="DeliveredTarget")
                {
                    if(value<0||value>100)
                    {
                        toast(`Target value should not be greater than 100.`, {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                    else
                    {
                        x.DeliveredTarget=value;
                    }
                     
                }
                else if(name==="SignedUpTarget")
                {
                    if(value<0||value>100)
                    {
                        toast(`Target value should not be greater than 100.`, {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                    else
                    {
                        x.SignedUpTarget= value;
                    }
                }
            }                               
            return x;
        });

        setESPData(tempParterList);
        setactiveFocus(name);
        setactiveRow(original.id);
	}; 

    const handleCursorPositionChange = (e) => {      
        setCursorPosition({selectionStart: e.target.selectionStart,selectionEnd: e.target.selectionEnd});
	};

    const onSaveTargetsClick = async () => 
    {
        if(!selectedYearOption)
        {
            toast(`Please select year.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }   
        
        if(!selectedPeriodOption)
        {
            toast(`Please select period.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }  

        if(selectedPeriodOption.value==="Quarter"&&!selectedQuarterOption)
        {
            toast(`Please select Quarter.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        } 
        
        if(selectedPeriodOption.value==="Month"&&!selectedMonthOption)
        {
            toast(`Please select Month.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }

        if(!selectedServiceNameOption)
        {
            toast(`Please select service.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        } 

        let isvalid=true;
        let sp_Targets=[];

        ESPData.map((x) => 
        {
            if(!x.DeliveredTarget)
            {
                isvalid=false;
            }
            
            if(!x.SignedUpTarget)
            {
                isvalid=false;
            }

            sp_Targets.push({refServicePartnerId:x.id,nDeliveredTarget:parseFloat(x.DeliveredTarget),nSignedUpTarget:parseFloat(x.SignedUpTarget)});
        });

        if(!isvalid)
        {
            toast(`All targets are required.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }

        let period="";

        if(selectedPeriodOption.value==="Quarter")
        {
            period=selectedQuarterOption.value;
        }
        else
        {
            period=selectedMonthOption.value;
        }

        let payload={
            sServiceResourceID:selectedServiceNameOption.value,
            sYear:selectedYearOption.value,
            sMeasuringUnit:selectedPeriodOption.value,
            sPeriod:period,
            sp_Details:sp_Targets
        }

        let request={payload_data:payload};
        saveESPTargets(request);
    };

    const saveESPTargets = (payload) => {
		setIsLoading(true);
        let temp = api.saveESPTargets(payload)
        .then((d) => {	
                setIsLoading(false);
                setSelectedServiceNameOption(null);
                setSelectedYearOption(null);
                setSelectedPeriodOption(null);
                setSelectedQuarterOption(null);
                setSelectedMonthOption(null);
                setESPData([]);
                let message="";
                d.data.message.map((x) => 
                {
                    message=message+x+"\n\n ";
                });

                toast(message, {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
        }).catch((error) =>
        {
            setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }            
        });
	};


    return(
        <>
            {
                activePage==="SPTargetsConfiguration"?
                (
                    <div className={`row row-container ${isLoading && "set-opacity"}`}>
                        {isLoading && <Spinner className="center-screen" />}

                        <div className="col-12">
                        <label><b>Add External Service Partner Targets</b></label>
                        </div>
                        <div className="col-md-12 inline-margin-facilitatorview">
                            <Select								
                                placeholder={"Select Financial Year"}
                                options={YearOptions}
                                onChange={(e) =>{ setSelectedYearOption(e)}}
                                value={selectedYearOption}
                                className='react-select-container'
                                classNamePrefix="react-select"
                                theme={theme => ({
                                    ...theme,
                                    colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                    },
                                })}
                            ></Select>

                            <Select								
                                placeholder={"Select Period"}
                                options={PeriodOptions}
                                onChange={(e) =>{ setSelectedPeriodOption(e)}}
                                value={selectedPeriodOption}
                                className='react-select-container'
                                classNamePrefix="react-select"
                                theme={theme => ({
                                    ...theme,
                                    colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                    },
                                })}
                            ></Select>

                            {
                                selectedPeriodOption&&selectedPeriodOption.value==="Quarter"?
                                (
                                    <Select								
                                        placeholder={"Select Quarter"}
                                        options={QuarterOptions}
                                        onChange={(e) =>{ setSelectedQuarterOption(e)}}
                                        value={selectedQuarterOption}
                                        className='react-select-container'
                                        classNamePrefix="react-select"
                                        theme={theme => ({
                                            ...theme,
                                            colors: {
                                            ...theme.colors,
                                            primary: '#76287C',
                                            primary25: '#F4DFF4',
                                            },
                                        })}
                                    ></Select>
                                ):
                                selectedPeriodOption&&selectedPeriodOption.value==="Month"?
                                (
                                    <Select								
                                        placeholder={"Select Month"}
                                        options={MonthOptions}
                                        onChange={(e) =>{ setSelectedMonthOption(e)}}
                                        value={selectedMonthOption}
                                        className='react-select-container'
                                        classNamePrefix="react-select"
                                        theme={theme => ({
                                            ...theme,
                                            colors: {
                                            ...theme.colors,
                                            primary: '#76287C',
                                            primary25: '#F4DFF4',
                                            },
                                        })}
                                    ></Select>
                                ):
                                ("")                             
                            }
                            <Select								
                                placeholder={"Select Service"}
                                options={serviceNameOption}
                                onChange={(e) =>{ setSelectedServiceNameOption(e)}}
                                value={selectedServiceNameOption}
                                className='react-select-container'
                                classNamePrefix="react-select"
                                theme={theme => ({
                                    ...theme,
                                    colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                    },
                                })}
                            ></Select>

                            {/*<Button className="inline-button" onClick={onSearchClick}>Search</Button>*/}
                        </div>
                        {
                            ESPData&&ESPData.length>0?
                            (
                                <div className="col-12 conv-mt25">
                                    {<ESPTargetsConfigurationGrid
                                        data={ESPData}
                                        handleInputChange={handleInputChange}
                                        activeFocus={activeFocus}
                                        activeRow={activeRow}
                                        handleCursorPositionChange={handleCursorPositionChange}
                                        CursorPosition={CursorPosition}
                                    />}

                                    <Button className="inline-button conv-mt25" onClick={onSaveTargetsClick}>Save Targets</Button>

                                </div>
                            )
                            :("")
                        }
                        
                    </div>
                )
                :
                activePage==="No_Access"?
                (
                    <div className={`row row-container`}>
                            <div className="col-12 row-margin-10px" style={{textAlign:"center"}}>                                
                            <label>
                                <b>You are not allowed to access this page, Please contact admin for more details.</b>
                            </label>         
                        </div>
                    </div>
                )
                :
                (
                    ""
                )
            }
        </>
    );
}